import { render } from "./CompanyPage.vue?vue&type=template&id=e2cebf72&scoped=true&ts=true"
import script from "./CompanyPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyPage.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyPage.vue?vue&type=style&index=0&id=e2cebf72&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2cebf72"],['__file',"src/pages/settings/pages/company/CompanyPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2cebf72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2cebf72', __exports__)) {
    api.reload('e2cebf72', __exports__)
  }
  
  module.hot.accept("./CompanyPage.vue?vue&type=template&id=e2cebf72&scoped=true&ts=true", () => {
    api.rerender('e2cebf72', render)
  })

}


export default __exports__